import React, { ReactNode, useState } from "react";
import { Carousel as SwipeableCarousel } from "react-swipeable-scroll-snap-carousel";

import { ArrowBackIosNew, ArrowForwardIos } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import MobileStepper from "@mui/material/MobileStepper";

import ImageDownloadMenuButton from "../../components/Utility/ImageDownloadMenuButton";

const Carousel = ({
  children,
  startIndex,
  imageIdsOrUrls,
}: {
  children: ReactNode[];
  startIndex?: number;
  imageIdsOrUrls: string[];
}) => {
  const [activeStep, setActiveStep] = useState(startIndex ?? 0);

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <div className="flex items-center flex-col gap-2">
      <div className="relative">
        <SwipeableCarousel onChangeIndex={handleStepChange} index={activeStep}>
          {React.Children.map(children, (child) => (
            <div className="flex justify-center h-full items-center">
              {child}
            </div>
          ))}
        </SwipeableCarousel>
        <div className="w-full flex justify-center mt-2">
          {imageIdsOrUrls.length > 0 && (
            <ImageDownloadMenuButton
              cloudinaryIdsOrImageUrls={imageIdsOrUrls}
              index={activeStep}
            />
          )}
        </div>
      </div>
      {children.length > 1 && (
        <div className="flex justify-between w-full max-w-sm">
          <MobileStepper
            steps={children.length}
            position="static"
            activeStep={activeStep}
            classes={{
              dot: "bg-neutral-300",
              dotActive: "bg-neutral-600",
            }}
            backButton={
              <IconButton
                onClick={() => handleStepChange(activeStep - 1)}
                disabled={activeStep === 0}
                className="text-neutral-600 disabled:text-neutral-300"
              >
                <ArrowBackIosNew />
              </IconButton>
            }
            nextButton={
              <IconButton
                onClick={() => handleStepChange(activeStep + 1)}
                disabled={activeStep === children.length - 1}
                className="text-neutral-600 disabled:text-neutral-300"
              >
                <ArrowForwardIos />
              </IconButton>
            }
            className="flex w-full"
          />
        </div>
      )}
    </div>
  );
};

export default Carousel;
